module.exports = __webpack_public_path__ + "static/media/phone.acbcab9b.svg";